/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { JX3 } from '@/store/types';
import * as api from '@/api/jx3';
import { Jx3Search } from '@/api/types/jx3';
import autocompleteModule, { StoreJx3SearchAutocompleteState } from './autocomplete';

export interface StoreJx3SearchState {
  lock: boolean;
  type: string;
  kw: string;
  offset: number;
  limit: number;
  result: Jx3Search[];
  server: string;
  noMore: boolean;
  // modules
  autocomplete: StoreJx3SearchAutocompleteState;
}

export default {
  namespaced: true,
  modules: {
    autocomplete: autocompleteModule,
  },
  state: {
    lock: false,
    type: null,
    kw: null,
    offset: 0,
    limit: 25,
    result: [],
    server: null,
    noMore: false,
  },
  getters: {
    result: (state) => {
      const result: Record<string, string>[] = [];
      if (state.server) {
        const server = Object.assign({
          recType: 'server',
        }, state.server);
        result.push(server);
      }
      state.result.forEach((item) => {
        const p = Object.assign({}, item);
        if (item.id) {
          p.id = item.id.replace(/^[^-]*-/u, '');
          p.recType = item.id.replace(/-.*$/u, '');
        } else if ((state.type === 'adventure' || state.type === 'pet') && p.name && p.region) {
          p.recType = 'server-link';
        } else {
          p.recType = state.type;
        }
        result.push(p);
      });
      if (state.type === 'adventure') {
        result.push({
          recType: 'copyright',
          text: '奇遇查询数据 Powered by “茗伊”',
        });
      } else if (state.type === 'pet') {
        result.push({
          recType: 'copyright',
          text: '宠物查询数据 Powered by “鸭鸭全知道”',
        });
      }
      return result;
    },
  },
  actions: {
    [JX3.SEARCH_REQUEST]({ commit, state }, params) {
      params.kw = params.kw || '';
      params.limit = params.limit || 25;
      if (state.type !== params.type || state.kw !== params.kw) {
        params.reload = true;
      }
      if ((
        // 未加锁 且 没有加载完 且列表为空（第一次加载）或带有loadmore标记
        !state.lock && !state.noMore && (params.more || state.result.length === 0)
      ) || params.reload) {
        commit(JX3.SEARCH_REQUEST, params);
        return new Promise((resolve, reject) => {
          if (params.kw === '' && params.type !== 'adventure' && params.type !== 'pet') {
            commit(JX3.SEARCH_REQUEST_SUCCESS, { data: [] });
            resolve();
          } else {
            api.getSearch(state).then((res) => {
              commit(JX3.SEARCH_REQUEST_SUCCESS, res);
              resolve();
            }).catch(reject);
          }
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [JX3.SEARCH_REQUEST](state, { reload, type, kw, limit }) {
      if (reload) {
        state.type = type;
        state.kw = kw;
        state.limit = limit;
        state.result = [];
        state.offset = 0;
      }
      state.lock = true;
    },
    [JX3.SEARCH_REQUEST_SUCCESS](state, { data: result, server }) {
      state.lock = false;
      state.result = result;
      state.server = server;
      state.offset += result.length;
    },
  },
};
